// extracted by mini-css-extract-plugin
export default {"container":"Kj-z","blurb":"Lj-z","links":"Mj-z"};